// Visible only when the app runs on the in-memory mock API. Lets you jump between demo states.
import { useState } from "react";
import { useNavigate } from "react-router";
import { api, isMock } from "../api";
import type { MockApi } from "../api/mock";
import { t } from "../i18n/sl";
import { useSession } from "../lib/session";

export function DemoPanel() {
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(() => new URLSearchParams(window.location.search).has("shot"));
  const { me, refresh } = useSession();
  const navigate = useNavigate();
  if (!isMock() || hidden) return null;
  const mock = api as unknown as MockApi;
  const go = async (mode: "demo" | "fresh" | "anon", to: string) => {
    mock.mockReset(mode);
    await refresh();
    setOpen(false);
    navigate(to);
  };
  return (
    <div className="demo-panel">
      {open && (
        <div className="demo-menu" role="menu">
          <p className="demo-hint">{t.common.demoBadgeHint}</p>
          <button role="menuitem" onClick={() => go("demo", "/app")}>{t.demo.loginDemo}</button>
          <button role="menuitem" onClick={() => go("fresh", "/app/zacetek")}>{t.demo.fresh}</button>
          <button role="menuitem" onClick={() => go("anon", "/")}>{t.demo.anon}</button>
          <button
            role="menuitem"
            onClick={async () => {
              mock.mockSetPilot(mock.mockPilot() === "closed" ? "open" : "closed");
              await refresh();
              setOpen(false);
            }}
          >
            {mock.mockPilot() === "closed" ? t.demo.pilotOff : t.demo.pilotOn}
          </button>
          {me?.user && (
            <>
              <button
                role="menuitem"
                onClick={async () => {
                  mock.mockConflictNext();
                  setOpen(false);
                }}
              >
                {t.demo.conflict}
              </button>
              <button
                role="menuitem"
                onClick={async () => {
                  mock.mockRevoke();
                  setOpen(false);
                  await refresh(); // the next signed-in call answers 403 revoked
                }}
              >
                {t.demo.revoke}
              </button>
            </>
          )}
          <button role="menuitem" onClick={() => setHidden(true)}>{t.demo.hide}</button>
        </div>
      )}
      <button className="demo-badge" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
        <span className="demo-dot" aria-hidden="true" />
        {t.common.demoBadge}
      </button>
    </div>
  );
}
